import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICustomerTemplateInput } from "@/interfaces/customer-template.interface";
import messageTemplateService from "@/services/message-template.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateMessageTemplateProps = UpdateByIdProps<ICustomerTemplateInput>;

export type UseUpdateMessageTemplateReturn = {
  update: (props: UpdateMessageTemplateProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateMessageTemplate = (): UseUpdateMessageTemplateReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } =
    useUpdate<ICustomerTemplateInput>({
      operation: (formData, id) => messageTemplateService.update(formData, id),
    });

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateMessageTemplate;
